import { Shield, Heart, Award, Clock } from "lucide-react";
import SectionTitle from "../SectionTitle";

const benefits = [
  {
    id: 1,
    icon: Shield,
    title: "Varnost na prvem mestu",
    description: "Delujemo po najvišjih standardih varnosti in uporabljamo najsodobnejšo opremo."
  },
  {
    id: 2,
    icon: Heart,
    title: "Individualen pristop",
    description: "Vsak pacient je obravnavan celostno in z individualno pozornostjo."
  },
  {
    id: 3,
    icon: Award,
    title: "Vrhunska strokovnost",
    description: "Stalno izobraževanje in uporaba najsodobnejših tehnik za najboljše rezultate."
  },
  {
    id: 4,
    icon: Clock,
    title: "Celovita podpora",
    description: "Od prvega posveta do popolnega okrevanja smo vam vedno na voljo."
  }
];

const WhyChooseUs = () => {
  return (
    <section className="container-section">
      <SectionTitle
        title="Zakaj izbrati nas?"
        subtitle="Naša klinika združuje strokovnost, vrhunske tehnologije in individualen pristop za vaše popolno zadovoljstvo."
        className="mb-12 md:mb-16"
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {benefits.map((benefit, index) => (
          <div 
            key={benefit.id} 
            className="glass-card text-center p-6 md:p-8 opacity-0 animate-fade-in"
            style={{ animationDelay: `${index * 100}ms` }}
          >
            <div className="w-16 h-16 bg-medical-100 text-medical-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <benefit.icon size={28} />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              {benefit.title}
            </h3>
            <p className="text-gray-600">
              {benefit.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;